const apiMixin = {
	data() {
		return {
			// apiUrl: 'http://residetape.vingtcinq.io/api/v1/',
			apiUrl: window.api_base_url
		};
	},
	methods: {
		buildHeaders() {
			let headers = {};
			headers['Content-Type'] = 'application/json';
			return headers;
		},
		post(endpoint, data = {}, multipart = false) {
			return axios({
				method: 'POST',
				url: this.apiUrl + endpoint,
				data: data,
				headers: this.buildHeaders()
			});
		},
		get(endpoint, data = {}, fullUrl = false) {
			fullUrl ? (endpoint = fullUrl) : (endpoint = this.apiUrl + endpoint);
			return axios({
				method: 'GET',
				url: endpoint,
				params: data,
				headers: this.buildHeaders()
			});
		},
		delete(endpoint, data = {}, auth = true) {
			return axios({
				method: 'DELETE',
				url: this.apiUrl + endpoint,
				data: data,
				headers: this.buildHeaders(auth)
			});
		}
	}
};
